<script setup lang="ts">
import { ref, shallowRef, watchEffect } from 'vue'
import ModalRecapPreview from '../ModalRecapPreview.vue'
import { Table } from '../../types/components/data-rendering'
import { useMerchPlanner } from '../../store/useMerchPlanner'
import { storeToRefs } from 'pinia'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
const loading = ref(true)
const data = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    const { getMerchPlannerData } = storeToRefs(useMerchPlanner())
    data.value = getMerchPlannerData.value
    loading.value = false
  },
  { flush: 'post' }
)

const isFetching = ref(false)
const { merchPlannerDisplayOptions } = useFilteringDisplayOptions({
  isFetching,
})

//Recap preview logic
const recap = ref(false)
const recapId = ref(null)
const previewRecap = (recap_id: any) => {
  recap.value = true
  recapId.value = recap_id
}
</script>
<template>
  <FilteringDataDisplay
    :key="data"
    :is-loading="loading"
    :table-data="data"
    :display-type="displayType"
    :options="merchPlannerDisplayOptions"
  >
    <template #recap="{ rowData }">
      <span @click="previewRecap(rowData['recap'])">
        Preview Recap ID: {{ rowData['recap'] }}
      </span>
    </template>
  </FilteringDataDisplay>
  <ModalRecapPreview v-model="recap" :recap-id="recapId" :recap-type="'task'" />
</template>
